import { render, staticRenderFns } from "./addcommercial_shxq.vue?vue&type=template&id=0da20bef&scoped=true&"
import script from "./addcommercial_shxq.vue?vue&type=script&lang=js&"
export * from "./addcommercial_shxq.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_shxq.vue?vue&type=style&index=0&id=0da20bef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da20bef",
  null
  
)

export default component.exports